import type { AuctionData } from "../../../core/AdEnginePlugin";
import { PrebidBidderAdapter } from "./PrebidBidderAdapter";

/**
 * OzoneBidderAdapter is a Prebid bidder adapter for Ozone.
 *
 * It modifies the bids configuration for the ad units to include all the pageTargeting
 * on the `bid.params.customData[].targeting` field
 */
export class OzoneBidderAdapter extends PrebidBidderAdapter<"ozone"> {
  transformAdUnitBidConfigs(
    bidderConfigs: PrebidAdUnitBidForKey["ozone"][],
    auctionData: AuctionData,
  ): PrebidAdUnitBidForKey["ozone"][] {
    for (const bid of bidderConfigs) {
      bid.params.customData = [
        {
          settings: {},
          targeting: {
            ...auctionData.pageTargeting,
          },
        },
      ];
    }

    return bidderConfigs;
  }
}
